<template>
  <div class="browser-tips" v-if="isOpenBrowser" :style="{opacity:isOpenBrowser?1:0}">
    <div class="tips-content">
      <img
        v-if="version.ios || version.iPhone || version.iPad"
        src="@/assets/images/guide-safari.jpg"
        srcset="@/assets/images/guide-safari@2x.jpg 2x, @/assets/images/guide-safari@3x.jpg 3x"
        class="guide"
      />
      <img
        v-if="version.android"
        src="@/assets/images/guide-andorid.jpg"
        srcset="@/assets/images/guide-andorid@2x.jpg 2x, @/assets/images/guide-andorid@3x.jpg 3x"
        class="guide"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isOpenBrowser: {
      default() {
        return false
      },
      required: true
    },
    version: {
      default() {
        return {}
      },
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../scss/rem.scss';
.browser-tips {
  position: absolute;
  z-index: 10000000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s linear;
  -webkit-transition: opacity 0.3s linear;
}
.tips-content {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  > img {
    width: 100%;
    // height:100%;
  }
}
</style>